import { render } from "./ItmightgetloudView.vue?vue&type=template&id=4696d850&scoped=true"
import script from "./ItmightgetloudView.vue?vue&type=script&lang=js"
export * from "./ItmightgetloudView.vue?vue&type=script&lang=js"

import "./ItmightgetloudView.vue?vue&type=style&index=0&id=4696d850&scoped=true&lang=css"

import exportComponent from "/Applications/MAMP/hosts/mageix.ch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4696d850"]])

export default __exports__